import React from 'react';
import { getOrderProgressBarJSX } from '../sharedTemplates/orderProcessingProgressBarTemplates';

const OrderProcessingProgressBarView = props => {
  return getOrderProgressBarJSX(props);
};

export default React.memo(OrderProcessingProgressBarView);
